import { render } from "./FlashMessages.vue?vue&type=template&id=cfd70128"
import script from "./FlashMessages.vue?vue&type=script&lang=js"
export * from "./FlashMessages.vue?vue&type=script&lang=js"

import "./FlashMessages.vue?vue&type=style&index=0&id=cfd70128&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__